import { regex } from '@prishapolicy/backend-core/masters';
import { trpcNoAuth } from '@prishapolicy/shared/trpc';
import { Button, Form, HeroBackground, showToast, TextInput, useWindowLocation } from '@prishapolicy/shared/ui';
import { NextSeo } from 'next-seo';
import Image from 'next/image';
import { object, string } from 'yup';
import contactUs from './contact-us.png';

const callBackValidation = object({
  personalDetails_phone: string().matches(regex.phone).required('Phone number is required'),
});
const CallBackForm = () => {
  const currentUrl = useWindowLocation();
  const mutation = trpcNoAuth['lead-management']['call-back-request']['raise'].useMutation();

  return (
    <div>
      <h4 className="heading-4">Arrange a call back</h4>
      <p>Prefer speaking with us? Enter your number, we will call you.</p>
      <Form
        initialValues={{
          personalDetails_phone: '',
        }}
        onSubmit={async (values) => {
          await mutation.mutateAsync({
            name: undefined,
            phone: values.personalDetails_phone,
            lead_sourceUrl: currentUrl,
          });

          showToast({
            title: 'Success',
            description: 'We will call you soon.',
          });
        }}
        validationSchema={callBackValidation}
      >
        <div className="mt-5 flex flex-col gap-2 lg:flex-row">
          <TextInput name="personalDetails_phone" label={false} />
          <Button type="submit" text="Call me back!" size="large" className="h-fit" disabled={mutation.isPending} />
        </div>
      </Form>
    </div>
  );
};

const WhatsappCallBackForm = () => {
  return (
    <div>
      <h4 className="heading-4">Talk to us on Whatsapp</h4>
      <p>Prefer chatting? Reach out to us through whatsapp</p>

      <Button
        leftIcon="whatsApp"
        type="submit"
        text="Chat with us"
        size="large"
        className="mt-5"
        href="https://api.whatsapp.com/send?phone=919311066007&text=hi"
        openInNewTab
      />
    </div>
  );
};

const chatEmails = [
  {
    name: 'Marketing',
    description: 'Our team is ready to help you grow give us the chance to be the one.',
    email: 'marketing@prishapolicy.com',
  },
  {
    name: 'POSP Support',
    description:
      'Want to join our endeavour and help grow the community, or having issues as an already existing POSP?',
    email: 'posphelpdesk@prishapolicy.com',
  },
  {
    name: 'Claims',
    description: 'Struggling with an insurance claim? Our team can assist you through it.',
    email: 'claims@prishapolicy.com',
  },
  {
    name: 'Anything Else?',
    description: 'Still have any queries? We are happy to lend a helping hand.',
    email: 'info@prishapolicy.com',
  },
];
export const ContactUs = () => {
  return (
    <>
      <NextSeo
        title="Contact Us | PrishaPolicy"
        description="At PrishaPolicy, we're more than just insurance brokers - we're your trusted advisors committed to providing personalized solutions that protect your interests and position you for long-term success."
      />
      <HeroBackground backgroundColor="teal-200">
        <div className="container grid-cols-2 text-center lg:grid lg:text-left">
          <div className="flex flex-col justify-center">
            <h1 className="heading-1 pb-3">
              A good service always,
              <br />
              comes to you.
            </h1>
            <p className="text-title-6 max-w-[600px]">
              At PrishaPolicy, we&apos;re more than just insurance brokers - we&apos;re your trusted advisors, committed
              to providing personalized solutions that protect your interests and position you for long-term success.
            </p>
          </div>
          <div className="flex w-full justify-center">
            <div className="mt-10 flex w-3/4 justify-center">
              <Image src={contactUs} alt="contact us" />
            </div>
          </div>
        </div>
      </HeroBackground>
      <div className="container my-16 grid-cols-2 gap-x-32 lg:grid">
        <div className="flex flex-col justify-between">
          <div>
            <h6 className="text-title-6 text-primary mb-4 font-medium">Let&apos;s chat</h6>
            <h1 className="heading-1 leading-tight">Who do you need to get in touch with?</h1>
          </div>
          <div className="hidden lg:block">
            <WhatsappCallBackForm />
          </div>
          <div className="hidden lg:block">
            <CallBackForm />
          </div>
        </div>
        <div className="my-9 flex flex-col gap-y-10 lg:m-0">
          {chatEmails.map((chatEmail, idx) => {
            return (
              <div key={idx}>
                <h4 className="text-title-5  font-semibold">{chatEmail.name}</h4>
                <p>{chatEmail.description}</p>
                <a href={`mailto:${chatEmail.email}`} className="text-primary">
                  {chatEmail.email}
                </a>
              </div>
            );
          })}
        </div>
        <div className="block lg:hidden">
          <WhatsappCallBackForm />
        </div>
        <div className="block lg:hidden">
          <CallBackForm />
        </div>
      </div>
    </>
  );
};

export default ContactUs;
